import { vpsb_insert_human_token, show_layout_modal } from './global';
import { showModal, hideModal } from './lib/bootstrap_components';

export class LoginModal {
  constructor(triggering_form, signed_in_redirect_url, options) {
    this.triggering_form = triggering_form;
    this.signed_in_redirect_url = signed_in_redirect_url;
    this.options = options;
  }

  load(label) {
    $.ajax({
      method: "GET",
      url: "/login_modal/show",
      success: (data) => {
        $('#login-modal-wrapper').html(data);
        $('#login-modal-label').html(label);

        if (this.options.show_skip_button) {
          $('#skip-button-container').removeClass('hidden');
          if (this.options.skip_button_label) {
            $('#skip-button').html(this.options.skip_button_label);
          }
          $('#skip-button').on('click', (e) => {
            e.preventDefault();
            this.moveOn(this.options.skip_url);
          });
        }

        this.setupLoginModalShown();
        this.show();
      },
      error: function(data) {
        console.log(`err: ${data}, code: ${data.status}`);
        alert(data);
      }
    });
  }

  show() {
    showModal('#login-modal');
  }

  setupLoginModalShown() {
    $('#login-modal').on('shown.bs.modal', (event) => {

      $('#login-button').on('click', (event) => {
        event.preventDefault();
        $('#login-or-signup').addClass('hidden');
        $('#login-form-wrapper').removeClass('hidden');
        $('#login-form-wrapper #user_email').focus();
        this.setupLoginForm();
      });

      $('#signup-button').on('click', (event) => {
        event.preventDefault();
        $('#login-or-signup').addClass('hidden');
        $('#signup-form-wrapper').removeClass('hidden');
        $('#signup-form-wrapper #user_first_name').focus();
        vpsb_insert_human_token('#new_user_form');
        this.setupSignupForm();
      });
    });
  }

  setupLoginForm() {
    $('#new_session_form').on('submit', (event) => {
      $('#login-form-alert').addClass('hidden');
      var formElt = event.currentTarget;
      event.preventDefault();
      $.ajax({
        url: $(formElt).prop('action'),
        type: 'POST',
        dataType: 'json',
        data : $(formElt).serialize(),
        success: (data) => {
          $('#login-form-wrapper').addClass('hidden');
          if (this.options.on_authenticated) {
            this.authentication_ready = this.options.on_authenticated();
          }
          this.showProceedButton("Logged in successfully");
        },
        error: (data, textStatus, xhr) => {
          var respBody = data.responseJSON;
          $('#login-form-alert').html(respBody.error);
          $('#login-form-alert').removeClass('hidden');
          console.log(`err: ${respBody.error}, code: ${data.status}`);
        }
      });
      return false;
    });
  }

  setupSignupForm() {
    $('#new_user_form').on('submit', (event) => {
      $('#signup-form-alert').addClass('hidden');
      var formElt = event.currentTarget;
      event.preventDefault();
      $.ajax({
        url: $(formElt).prop('action'),
        type: 'POST',
        dataType: 'json',
        data : $(formElt).serialize(),
        success: (data) => {
          $('#signup-form-wrapper').addClass('hidden');
          if (this.options.on_authenticated) {
            this.authentication_ready = this.options.on_authenticated();
          }
          this.showProceedButton("Signed up successfully");
        },
        error: (data) => {
          var resp = data.responseJSON;
          if (resp && resp.redirect) {
            window.location.assign(resp.redirect);
            return;
          }

          var errors = resp && resp.errors;
          var errorMessage = errors ? JSON.stringify(errors) : "Sign up could not be completed. Please complete the security check and try again.";
          $('#signup-form-alert').html(errorMessage);
          $('#signup-form-alert').removeClass('hidden');
          console.log(`err: ${errorMessage}, code: ${data.status}`);
        }
      });
      return false;
    });
  }

  showProceedButton(label) {
    console.debug('showProceedButton with label', label);
    $('#proceed-form-label').html(label);
    $('#login-result').removeClass('hidden');

    $('#proceed-button').off('click');
    $('#proceed-button').on('click', (e) => {
      e.preventDefault();
      console.debug('showProceedButton proceed button click');
      this.moveOn();
    });
  }

  moveOn(gotoUrl) {
    if (arguments.length > 0 && gotoUrl !== undefined && gotoUrl !== '' && gotoUrl !== null) {
      Turbo.visit(gotoUrl);
    } else if (this.signed_in_redirect_url) {
      Turbo.visit(this.signed_in_redirect_url);
    } else if (this.triggering_form) {
      if (this.authentication_ready) {
        this.authentication_ready.then(() => this.submitTriggeringForm());
      } else {
        this.submitTriggeringForm();
      }
    }
  }

  submitTriggeringForm() {
    if (this.options.before_submit) {
      this.options.before_submit();
    }

    var targetUrl = $(this.triggering_form).prop('action');
    var targetMethod = $(this.triggering_form).prop('method');
    var targetParams = $(this.triggering_form).serialize();
    $.ajax({
      method: targetMethod,
      url: targetUrl,
      data: targetParams,
      dataType: 'json',
      success: (data) => {
        console.log('redirecting to ', data.redirect);
        Turbo.visit(data.redirect);
      },
      error: (data) => {
        console.log(`err: ${data.responseJSON.errors.join(', ')}, code: ${data.status}`);
        if (this.options.on_submit_error) {
          this.options.on_submit_error();
        }
        hideModal('#login-modal');
        show_layout_modal(data.responseJSON.errors.join(', '));
      }
    });
  }
}

